<template>
  <form @submit.prevent="onSearch">
    <div class="row mt-3 mb-2">
      <div class="col-lg-5 col-md-6 col-sm-12">
        <div v-if="officeDropdown && officeDropdown.length">
          <SelectVue
              v-model="filters.officeId"
              :options="officeDropdown"
              :is-clear="true"
              :placeholder="$t('placeholder.office_name')"
          />
        </div>
      </div>
      <div class="col-lg-2 col-sm-12 col-12">
        <SearchButton
            type="submit"
            :label="$t('general.button.search')"
            :loading="loading"/>
      </div>
    </div>
  </form>
</template>

<script setup>
import SelectVue from '@/components/SelectVue.vue';
import { defineEmits, defineProps, toRefs } from 'vue';
import SearchButton from "@/components/button/SearchButton.vue";

// Define props
const props = defineProps({
  filters: {
    type: Object,
    required: true,
  },
  loading: {
    type: Boolean,
    default: false,
  },
  type: {
    type: String,
    default: '',
  },
  officeDropdown: {
    type: Array,
    required: true,
  },
});

// Emit search event
const emit = defineEmits([ 'search' ]);

// Use toRefs to maintain reactivity
const { filters }    = toRefs(props);
const officeDropdown = toRefs(props)[ 'officeDropdown' ];

function onSearch() {
  emit('search', 1, undefined, filters.value);
}


</script>

<style scoped>
</style>
